module.exports = __webpack_public_path__ + "f01690be760f2957b0429a53a4157645.png";